interface BaseFillExclamationProps extends React.SVGProps<SVGSVGElement> {
  accentColor?: string;
}

export const BaseFillExclamation = ({ accentColor = '#fff', ...props }: BaseFillExclamationProps) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 22C14.7614 22 17.2614 20.8807 19.0711 19.0711C20.8807 17.2614 22 14.7614 22 12C22 9.2386 20.8807 6.7386 19.0711 4.92893C17.2614 3.11929 14.7614 2 12 2C9.2386 2 6.7386 3.11929 4.92893 4.92893C3.11929 6.7386 2 9.2386 2 12C2 14.7614 3.11929 17.2614 4.92893 19.0711C6.7386 20.8807 9.2386 22 12 22Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M12 7.5V12.5" stroke={accentColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    <path d="M12 16.5V16.25" stroke={accentColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" />
  </svg>
);
